<!-- STRAT NAVBAR -->
<nav class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark" id="navbar"
    (window:scroll)="windowScroll()">
    <div class="container">
        <style>
            @media only screen and (max-width: 479px) {
                .centram {
                   text-align: center;
                   
                }
                #loguito{
                width:37%;
                }
                .navbar-brand {
                    float: left;
                    margin-bottom: 10px;
                }
            }
        
            @media only screen and (min-width: 480px) {
                
                #loguito{
                width:27%;
                }
            }
        </style>
        <div class="centram">
           
<a  class="navbar-brand" href="javascript:void(0);"><img id="loguito"  src="./assets/images/logotipo.png"
        alt="Expocomunicarte2023"></a>
<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
    style="background-color:#fff;" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation"
    (click)="toggleMenu()">
    <span class="ti-menu"></span>
</button>
        </div>
        

        <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav mx-auto" id="navbar-navlist">
                <li class="nav-item" [ngClass]="{'active':currentSection === 'home'}">
                    <a [ngxScrollTo]="'#home'" class="nav-link" href="javascript: void(0);">INICIO</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'services'}">
                    <a [ngxScrollTo]="'#services'" class="nav-link" href="javascript: void(0);" style="width: 193px;">EXPOCOMUNICARTE 2023</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'features'}">
                    <a [ngxScrollTo]="'#features'" class="nav-link" href="javascript: void(0);">AGENDA</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'team'}">
                    <a [ngxScrollTo]="'#team'" class="nav-link" href="javascript: void(0);">EVENTOS</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'testi'}">
                    <a [ngxScrollTo]="'#testi'" class="nav-link" href="javascript: void(0);">CRONOLOGÍA</a>
                </li>
                <!-- <li class="nav-item" [ngClass]="{'active':currentSection === 'faq'}">
                    <a [ngxScrollTo]="'#faq'" class="nav-link" href="javascript: void(0);">FAQ</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'pricing'}">
                    <a [ngxScrollTo]="'#pricing'" class="nav-link" href="javascript: void(0);">Pricing</a>
                </li>
                <li class="nav-item" [ngClass]="{'active':currentSection === 'contact'}">
                    <a [ngxScrollTo]="'#contact'" class="nav-link" href="javascript: void(0);">Contact</a>
                </li> -->
            </ul>
            <!-- <div>
                <ul class="text-right list-unstyled list-inline mb-0 nav-social">
                    <li class="list-inline-item text-white nav-number"><i class="ti-mobile"></i> <span>+1 234 567
                            789</span></li>
                    <li class="list-inline-item"><a href="" class="facebook"><i class="ti-facebook"></i></a></li>
                </ul>
            </div> -->
        </div>
    </div>
</nav>
<!-- END NAVBAR -->
<div appScrollspy [spiedTags]="['SECTION']" (sectionChange)="onSectionChange($event)">
<!-- START HOME -->
<section class="section bg-home-full vh-100 bg-home" id="home">
    <div class="home-center">
        <div class="home-desc-center">
            <div class="container slidero">
                <div class="row justify-content-center">
                    <div class="col-lg-10">
                        <div class="text-center">
                            <h1 class="fontl text-white home-title mb-0" style="font-size: 22px; letter-spacing: 10px;">EXPOCOMUNICARTE 2023 </h1>
                            <p class="fontt text-muted home-subtitle-center mx-auto home-subtitle mt-4 mb-0" style="font-size: 45px; color: white !important;">C<strong style="font-family: 'Montserrat-Regular', sans-serif;color: white;">IENCIA & <strong class="fontt text-muted home-subtitle-center mx-auto home-subtitle mt-4 mb-0" style="font-size: 45px; color: white !important;">F</strong>UTURO</strong></p>
                            <h1 class="fontl text-white home-title mb-0" style="font-size: 22px; letter-spacing: 10px; padding-top: 2%;">29 NOV - 01 DIC 2023</h1>
                            <!-- <div class="mt-4">
                                <a href="javascript:void(0);" class="btn btn-primary btn-round">CONCURSOS</a>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-particles [id]="id" [options]="particlesOptions" [particlesInit]="particlesInit" (particlesLoaded)="particlesLoaded($event)"></ng-particles>
</section>
<!-- END HOME -->

    <app-services></app-services>
    <app-features></app-features>
    <app-team></app-team>
    <app-client></app-client>
    <!-- <app-faq></app-faq> -->
    <!-- <app-pricing></app-pricing> -->
    <!-- <app-contact></app-contact> -->
    <app-footer></app-footer>
    <!-- <app-switcher></app-switcher> -->
</div>